import React from 'react'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Stack from '@mui/material/Stack'

import { AccountBalance, ChevronRight } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

import ConnectDrawer from './ConnectDrawer'

interface ConnectCardProps {
  description: string
  label: string
  title: string
}

export const ConnectCard = ({ description, label, title }: ConnectCardProps) => {
  const [isConnectOpen, setIsConnectOpen] = React.useState(false)

  return (
    <React.Fragment>
      <Card sx={{ m: 24 }}>
        <CardHeader
          avatar={<AccountBalance />}
          sx={{ '.MuiCardHeader-avatar': { mr: 8 } }}
          title={
            <Text bold={true} variant="body1">
              {title}
            </Text>
          }
        />
        <CardContent sx={{ ':last-child': { pb: 4 }, ml: 28, py: 0 }}>
          <Stack alignItems="flex-start" spacing={2}>
            <Text color="text.secondary" variant="subtitle2">
              {description}
            </Text>
            <Button
              endIcon={<ChevronRight />}
              onClick={() => setIsConnectOpen(true)}
              sx={{
                pl: 0,
                ':hover': {
                  bgcolor: 'unset',
                },
              }}
              variant="text"
            >
              {label}
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <ConnectDrawer
        onClose={() => setIsConnectOpen(false)}
        showConnectWidget={isConnectOpen}
        title={label}
      />
    </React.Fragment>
  )
}
